var autoCompleteHitTemplates = {};

autoCompleteHitTemplates.product = function(product) {
    var output = ' \
        <li class="autocomplete-product"> \
        <a href="' + product.urlFront + '"> \
            <span>' + product.title + '</span><br> \
            <span>' + product.authors + '</span> \
        </a> \
        </li> \
    ';

    return output;
}

autoCompleteHitTemplates.category = function(category) {
    var output = ' \
        <li class="autocomplete-category"> \
        <a href="' + category.urlFront + '"> \
            <span>' + category.description + '</span><br> \
        </a> \
        </li> \
    ';

    return output;
}

autoCompleteHitTemplates.author = function(author) {
    var output = ' \
        <li class="autocomplete-author"> \
        <a href="' + author.urlFront + '"> \
            <span>' + author.description + '</span><br> \
        </a> \
        </li> \
    ';

    return output;
}

autoCompleteHitTemplates.faq = function(faq) {

    var output = ' \
        <li class="autocomplete-faq"> \
            <span data-id="' + faq.id + '"> \
                <dl class="dl-vertical"> \
                    <dt>' + faq.question + '</dd> \
                    <dt>' + faq.answer + '</dd> \
                </dl> \
            </span> \
        </li> \
    ';

    return output;
}

autoCompleteHitTemplates.publisher = function(publisher) {
    var output = ' \
        <li class="autocomplete-publisher"> \
        <a href="' + publisher.urlFront + '"> \
            <span>' + publisher.description + '</span><br> \
        </a> \
        </li> \
    ';

    return output;
}